<div class="language-selector">
  <p-select [options]="languages" [(ngModel)]="selectedLanguage" (onChange)="onLanguageChange($event)"
    optionLabel="name" [showClear]="false" placeholder="{{ 'LANGUAGE.SELECT' | translate }}"
    styleClass="language-dropdown">

    <ng-template pTemplate="selectedItem">
      @if (selectedLanguage) {
        <div class="selected-language">
          <img [src]="selectedLanguage.flag" [alt]="selectedLanguage.name" title="{{selectedLanguage.name}}"
            class="flag-icon">
            <span class="language-name">{{ selectedLanguage.name }}</span>
          </div>
        }
      </ng-template>

      <ng-template let-language pTemplate="item">
        <div class="language-option">
          <img [src]="language.flag" [alt]="language.name" title="{{language.name}}" class="flag-icon">
          <span class="language-name">{{ language.name }}</span>
        </div>
      </ng-template>
    </p-select>
  </div>